import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useAuth } from '../../contexts/AuthContext'

const TABS = [
  { id: 'overview', label: 'Overview', path: '/monitor-safe/daily-data', end: true },
  { id: 'turnover', label: 'Turnover', path: '/monitor-safe/daily-data/turnover' },
  { id: 'dimpatron', label: 'DimPatron', path: '/monitor-safe/daily-data/dimpatron' },
  { id: 'visitor', label: 'Visitors', path: '/monitor-safe/daily-data/visitor' },
  { id: 'egm', label: 'EGM', path: '/monitor-safe/daily-data/egm' },
  { id: 'sessions', label: 'Sessions', path: '/monitor-safe/daily-data/sessions' },
  { id: 'meter', label: 'Meter', path: '/monitor-safe/daily-data/meter' },
  { id: 'slot-analysis', label: 'Slot analysis', path: '/monitor-safe/daily-data/slot-analysis' },
  { id: 'manage', label: 'Manage data', path: '/monitor-safe/daily-data/manage' },
]

function isActive(pathname, tab) {
  if (tab.end) return pathname === tab.path || pathname === `${tab.path}/`
  return pathname === tab.path || pathname.startsWith(`${tab.path}/`)
}

export default function DailyDataNav() {
  const { pathname } = useLocation()
  const { can } = useAuth()
  const canManageSettings = can('admin/system', 'view')

  return (
    <nav className="flex flex-wrap gap-1 border-b border-gray-200 mb-6" aria-label="Daily Data sections">
      {TABS.map((tab) => {
        const active = isActive(pathname, tab)
        return (
          <Link
            key={tab.id}
            to={tab.path}
            className={`px-3 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ${
              active
                ? 'border-primary-600 text-primary-700'
                : 'border-transparent text-gray-600 hover:text-gray-900 hover:border-gray-300'
            }`}
          >
            {tab.label}
          </Link>
        )
      })}
      {canManageSettings && (
        <Link
          to="/monitor-safe/daily-data/settings"
          className={`px-3 py-2 text-sm font-medium border-b-2 -mb-px transition-colors ml-auto ${
            pathname.startsWith('/monitor-safe/daily-data/settings')
              ? 'border-primary-600 text-primary-700'
              : 'border-transparent text-gray-500 hover:text-gray-900 hover:border-gray-300'
          }`}
        >
          Settings
        </Link>
      )}
    </nav>
  )
}
